/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Choose_TitleInputs */

const en_plan_choose_title = /** @type {(inputs: Plan_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where do you want to start?`)
};

const id_plan_choose_title = /** @type {(inputs: Plan_Choose_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mau mulai dari mana?`)
};

/**
* | output |
* | --- |
* | "Where do you want to start?" |
*
* @param {Plan_Choose_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const plan_choose_title = /** @type {((inputs?: Plan_Choose_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choose_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_plan_choose_title(inputs)
	return en_plan_choose_title(inputs)
});